import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'EmergencyService',
    controller: 'TaskSetting'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GetItemById',
    'FindByConditions',
    'GetPageContentByConditions'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const PlantasksettingApi = ZJApi.defineNewApi('PlantasksettingApi', factory);

export default PlantasksettingApi;